import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'

interface DayHeaderProps {
  day: string
}

export const DayHeader: React.FC<DayHeaderProps> = ({ day }) => {
  return (
    <div className='ProfessionalReservations__dayHeader'>
      <Typography variant='content2' weight='bold'>
        {day}
      </Typography>
    </div>
  )
}